import { CountryCode } from '../../index.js';
import { DKTribunalCaseType } from './countries/denmark.js';
import { GLTribunalCaseType } from './countries/greenland.js';
export const TribunalCaseType = {
    // Denmark
    ...DKTribunalCaseType,
    // Greenland
    ...GLTribunalCaseType,
};
export var TribunalCaseStatus;
(function (TribunalCaseStatus) {
    // Common
    TribunalCaseStatus["Created"] = "CREATED";
    TribunalCaseStatus["Closed"] = "CLOSED";
    // Denmark
    TribunalCaseStatus["Awaiting1Paategning"] = "AWAITING1PAATEGNING";
    TribunalCaseStatus["Awaiting2Paategning"] = "AWAITING2PAATEGNING";
    TribunalCaseStatus["AwaitingNoticeForBailiffMeeting"] = "AWAITINGNOTICEFORBAILIFFMEETING";
    TribunalCaseStatus["AwaitingBailiffMeeting"] = "AWAITINGBAILIFFMEETING";
    TribunalCaseStatus["ClosedBecauseOfObjection"] = "CLOSEDBECAUSEOFOBJECTION";
    // Greenland
    TribunalCaseStatus["AwaitingVerdict"] = "AWAITINGVERDICT";
    TribunalCaseStatus["AwaitingNoticeForFogedmoede"] = "AWAITINGNOTICEFORFOGEDMOEDE";
    TribunalCaseStatus["AwaitingFogedmoede"] = "AWAITINGFOGEDMOEDE";
})(TribunalCaseStatus || (TribunalCaseStatus = {}));
export const tribunalCaseTypesByCountry = {
    [CountryCode.DK]: Object.values(DKTribunalCaseType),
    [CountryCode.GL]: [
        ...Object.values(GLTribunalCaseType),
        ...Object.values(DKTribunalCaseType),
    ],
    [CountryCode.NO]: [],
    [CountryCode.SE]: [],
};
//# sourceMappingURL=types.js.map